import { gql } from "@apollo/client";
import { ApiRoutes } from "../common/variables/apiRoutes";

export const GET_EVENTS_BY_CUSTOMER = gql`
  query GetEventsByCustomer(
    $customerId: String!
    $fromDate: String
    $pageSize: Int
    $lastEvaluatedKey: String
  ) {
    events(
      customerId: $customerId
      fromDate: $fromDate
      pageSize: $pageSize
      lastEvaluatedKey: $lastEvaluatedKey
    )
      @rest(
        method: "GET"
        type: "EventsApiResponse"
        path: "${ApiRoutes.EventsByCustomer}?customerId={args.customerId}&fromDate={args.fromDate}&pageSize={args.pageSize}&lastEvaluatedKey={args.lastEvaluatedKey}"
      ) {
      message
      data
      timestamp
      lastEvaluatedKey
    }
  }
`;

export const GET_EVENTS_BY_FACILITY = gql`
  query GetEventsByFacility(
    $customerId: String!
    $facilityId: String!
    $fromDate: String
    $pageSize: Int
    $lastEvaluatedKey: String
  ) {
    events(
      customerId: $customerId
      facilityId: $facilityId
      fromDate: $fromDate
      pageSize: $pageSize
      lastEvaluatedKey: $lastEvaluatedKey
    )
      @rest(
        method: "GET"
        type: "EventsApiResponse"
        path: "${ApiRoutes.EventsByFacility}?customerId={args.customerId}&facilityId={args.facilityId}&fromDate={args.fromDate}&pageSize={args.pageSize}&lastEvaluatedKey={args.lastEvaluatedKey}"
      ) {
      message
      data
      timestamp
    }
  }
`;

export const GET_EVENTS_BY_MODEL = gql`
  query GetEventsByModel(
    $customerId: String!
    $modelId: String
    $fromDate: String
    $pageSize: Int
    $lastEvaluatedKey: String
  ) {
    events(
      customerId: $customerId
      modelId: $modelId
      fromDate: $fromDate
      pageSize: $pageSize
      lastEvaluatedKey: $lastEvaluatedKey
    )
      @rest(
        method: "GET"
        type: "EventsApiResponse"
        path: "${ApiRoutes.EventsByModel}?customerId={args.customerId}&modelId={args.modelId}&fromDate={args.fromDate}&pageSize={args.pageSize}&lastEvaluatedKey={args.lastEvaluatedKey}"
      ) {
      message
      data
      timestamp
    }
  }
`;

export const GET_EVENTS_BY_MODEL_AND_FACILITY = gql`
  query GetEventsByModelAndFacility(
    $customerId: String!
    $modelId: String!
    $facilityId: String!
    $fromDate: String
    $pageSize: Int
    $lastEvaluatedKey: String
  ) {
    events(
      customerId: $customerId
      modelId: $modelId
      facilityId: $facilityId
      fromDate: $fromDate
      pageSize: $pageSize
      lastEvaluatedKey: $lastEvaluatedKey
    )
      @rest(
        method: "GET"
        type: "EventsApiResponse"
        path: "${ApiRoutes.EventsByModelAndFacility}?customerId={args.customerId}&modelId={args.modelId}&facilityId={args.facilityId}&fromDate={args.fromDate}&pageSize={args.pageSize}&lastEvaluatedKey={args.lastEvaluatedKey}"
      ) {
      message
      data
      timestamp
    }
  }
`;

export const GET_RECORDINGS_BY_EVENT = gql`
  query GetRecordingsByEvent(
    $customerId: String!
    $eventTimestamp: String!
    $pageSize: Int
    $lastEvaluatedKey: String
  ) {
    recordings(
      customerId: $customerId
      eventTimestamp: $eventTimestamp
      pageSize: $pageSize
      lastEvaluatedKey: $lastEvaluatedKey
    )
      @rest(
        method: "GET"
        type: "RecordingsApiResponse"
        path: "${ApiRoutes.RecordingsByEvent}?customerId={args.customerId}&eventTimestamp={args.eventTimestamp}&pageSize={args.pageSize}&lastEvaluatedKey={args.lastEvaluatedKey}"
      ) {
      message
      data
      timestamp
      lastEvaluatedKey
    }
  }
`;

export const GET_RECORDINGS_BY_FACILITY = gql`
  query GetRecordingsByFacility(
    $customerId: String!
    $facilityId: String!
    $pageSize: Int
    $lastEvaluatedKey: String
  ) {
    recordings(
      customerId: $customerId
      facilityId: $facilityId
      pageSize: $pageSize
      lastEvaluatedKey: $lastEvaluatedKey
    )
      @rest(
        method: "GET"
        type: "RecordingsByFacilityApiResponse"
        path: "${ApiRoutes.RecordingsByFacility}?customerId={args.customerId}&facilityId={args.facilityId}&pageSize={args.pageSize}&lastEvaluatedKey={args.lastEvaluatedKey}"
      ) {
      message
      data
      timestamp
    }
  }
`;

export const GET_RECORDINGS_BY_MODEL = gql`
  query GetRecordingsByModel(
    $customerId: String!
    $modelId: String!
    $pageSize: Int
    $lastEvaluatedKey: String
  ) {
    recordings(
      customerId: $customerId
      modelId: $modelId
      pageSize: $pageSize
      lastEvaluatedKey: $lastEvaluatedKey
    )
      @rest(
        method: "GET"
        type: "RecordingsApiResponse"
        path: "${ApiRoutes.RecordingsByModel}?customerId={args.customerId}&modelId={args.modelId}&pageSize={args.pageSize}&lastEvaluatedKey={args.lastEvaluatedKey}"
      ) {
      message
      data
      timestamp
    }
  }
`;

export const GET_RECORDINGS_BY_MODEL_AND_FACILITY = gql`
  query GetRecordingsByModelAndFacility(
    $customerId: String!
    $modelId: String
    $facilityId: String
    $deviceId: String
    $fromDate: String
    $toDate: String
    $pageSize: Int
    $lastEvaluatedKey: String
  ) {
    recordings(
      customerId: $customerId
      modelId: $modelId
      facilityId: $facilityId
      deviceId: $deviceId
      fromDate: $fromDate
      toDate: $toDate
      pageSize: $pageSize
      lastEvaluatedKey: $lastEvaluatedKey
    )
      @rest(
        method: "GET"
        type: "RecordingsApiResponse"
        path: "${ApiRoutes.RecordingsByModelAndFacility}?customerId={args.customerId}&modelId={args.modelId}&facilityId={args.facilityId}&deviceId={args.deviceId}&fromDate={args.fromDate}&toDate={args.toDate}&pageSize={args.pageSize}&lastEvaluatedKey={args.lastEvaluatedKey}"
      ) {
      message
      data
      timestamp
      lastEvaluatedKey
    }
  }
`;

export const GET_EVENT_DETAILS = gql`
  query GetEventDetails($pk: String!, $sk: String!) {
    eventDetails(pk: $pk, sk: $sk)
      @rest(
        method: "GET"
        type: "EventApiResponse"
        path: "${ApiRoutes.GetEventDetails}?pk={args.pk}&sk={args.sk}"
      ) {
      message
      data
      timestamp
    }
  }
`;

export const GET_RECENT_EVENTS = gql`
  query GetRecentEvents(
    $customerId: String!
    $modelId: String
    $facilityId: String
    $fromDate: String
    $toDate: String
    $pageSize: Int
    $lastEvaluatedKey: String
  ) {
    events(
      customerId: $customerId
      modelId: $modelId
      facilityId: $facilityId
      fromDate: $fromDate
      toDate: $toDate
      pageSize: $pageSize
      lastEvaluatedKey: $lastEvaluatedKey
    )
      @rest(
        method: "GET"
        type: "EventsApiResponse"
        path: "${ApiRoutes.GetRecentEvents}?customerId={args.customerId}&modelId={args.modelId}&facilityId={args.facilityId}&fromDate={args.fromDate}&toDate={args.toDate}&pageSize={args.pageSize}&lastEvaluatedKey={args.lastEvaluatedKey}"
      ) {
        message
      data
      timestamp
      lastEvaluatedKey
    }
  }
`;
